var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.837C30 16.0054 30 14.0896 28.8284 12.8993C27.6569 11.709 25.7712 11.709 22 11.709H20C16.2288 11.709 14.3432 11.709 13.1716 12.8993C12 14.0896 12 16.0054 12 19.837C12 23.6686 12 25.5844 13.1716 26.7747C13.6412 27.2518 14.2255 27.5377 15 27.709",
    stroke: "url(#paint0_linear_2501_2561)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27.209C32 25.3341 32 24.3967 31.5225 23.7395C31.3683 23.5273 31.1817 23.3407 30.9695 23.1865C30.3123 22.709 29.3749 22.709 27.5 22.709H22.5C20.6251 22.709 19.6877 22.709 19.0305 23.1865C18.8183 23.3407 18.6317 23.5273 18.4775 23.7395C18 24.3967 18 25.3341 18 27.209C18 29.0839 18 30.0213 18.4775 30.6785C18.6317 30.8907 18.8183 31.0773 19.0305 31.2315C19.6877 31.709 20.6251 31.709 22.5 31.709H27.5C29.3749 31.709 30.3123 31.709 30.9695 31.2315C31.1817 31.0773 31.3683 30.8907 31.5225 30.6785C32 30.0213 32 29.0839 32 27.209Z",
    stroke: "url(#paint1_linear_2501_2561)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 25.709L27.4199 26.5019C27.8066 26.8352 28 27.0019 28 27.209C28 27.4161 27.8066 27.5828 27.4199 27.9161L26.5 28.709",
    stroke: "url(#paint2_linear_2501_2561)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 25.709L22.5801 26.5019C22.1934 26.8352 22 27.0019 22 27.209C22 27.4161 22.1934 27.5828 22.5801 27.9161L23.5 28.709",
    stroke: "url(#paint3_linear_2501_2561)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.709H29.5",
    stroke: "url(#paint4_linear_2501_2561)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_2561",
    x1: 12,
    y1: 19.709,
    x2: 30,
    y2: 19.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_2561",
    x1: 18,
    y1: 27.209,
    x2: 32,
    y2: 27.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_2561",
    x1: 26.5,
    y1: 27.209,
    x2: 28,
    y2: 27.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_2561",
    x1: 22,
    y1: 27.209,
    x2: 23.5,
    y2: 27.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2501_2561",
    x1: 12.5,
    y1: 16.209,
    x2: 29.5,
    y2: 16.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.8d4600af01e7929a094f62c8babcd551.svg";
export { ForwardRef as ReactComponent };